import React from "react";

const IframePage = ({
  title,
  description,
  iframeUrl,
  classPrefix = "iframepage",
}) => (
  <div className={`${classPrefix}-full-bg`}>
    <div className={`${classPrefix}-container`}>
      <h1 className={`${classPrefix}-title`}>{title}</h1>
      <p className={`${classPrefix}-desc`}>{description}</p>
      <div className={`${classPrefix}-iframe-block`}>
        <iframe
          title={title}
          src={iframeUrl}
          width="100%"
          height="100%"
          allowTransparency="true"
          loading="lazy"
          style={{
            width: "100%",
            minHeight: "60vh",
            height: "90vh",
            border: "1px solid #e0e0e0",
            borderRadius: 12,
            background: "#fff",
            display: "block",
          }}
        ></iframe>
      </div>
    </div>
  </div>
);

export default IframePage;